import { useState } from 'react'
import { useLocation } from 'react-router-dom'
import General from 'services/General'
import Comission from 'services/Comission'
import AdminNavbar from 'components/Navbars/AdminNavbar'
import DailyCutileiServicesModal from 'pages/Admin/Modals/DailyCutileiServicesModal'

import { 
  Container, 
  BusinessContainer,
  LabelRow,
  SubTitle,
  MoneyTextMask
} from '../../styles'

export default function AdminDailyExpenses () {
  const location = useLocation ()
  const [selectedSchedules, setSelectedSchedules] = useState (null)
  const [showDetails, setShowDetails] = useState (false)
  const { formattedDay, daySchedules } = location.state
  const cutileiFilter = { value: 'cutilei' }
  const dayTotalExpenses = Comission.getTotalEarnings (daySchedules, cutileiFilter, null)
  const dayBusinessExpenses = Comission.getBusinessEarnings (daySchedules, cutileiFilter, null)
  const dayProfessionalExpenses = Comission.getProfessionalEarnings (daySchedules, cutileiFilter, null)
  const schedulesByDay = daySchedules.map (schedule => ({
    ...schedule,
    business_id: schedule.business.id
  }))

  const schedulesByBusiness = General.groupBy (schedulesByDay, 'business_id')

  const handleSelect = schedules => {
    setSelectedSchedules (schedules)
    setShowDetails (true)
  }

  return (
    <Container>
      <AdminNavbar/>
      <SubTitle>Total do dia - {formattedDay}</SubTitle>
      <LabelRow style={{gridTemplateColumns: 'repeat(4, 1fr)'}}>
        <SubTitle>Salão</SubTitle>
        <SubTitle>Despesa total</SubTitle>
        <SubTitle>Comissão dos salões</SubTitle>
        <SubTitle>Comissão dos profissionais</SubTitle>
      </LabelRow>
      <BusinessContainer>
        <SubTitle>TOTAL</SubTitle>
        <MoneyTextMask value={dayTotalExpenses}/>
        <MoneyTextMask value={dayBusinessExpenses}/>
        <MoneyTextMask value={dayProfessionalExpenses}/>
      </BusinessContainer>
      {schedulesByBusiness.map ((schedules, index) => {
        const { business } = schedules[0]
        const totalExpenses = Comission.getTotalEarnings (schedules, cutileiFilter)
        const businessExpenses = Comission.getBusinessEarnings (schedules, cutileiFilter)
        const professionalExpenses = Comission.getProfessionalEarnings (schedules, cutileiFilter)

        return (
          <BusinessContainer key={index} onClick={() => handleSelect (schedules)}>
            <SubTitle>{business.name}</SubTitle>
            <MoneyTextMask value={totalExpenses}/>
            <MoneyTextMask value={businessExpenses}/>
            <MoneyTextMask value={professionalExpenses}/>
          </BusinessContainer>
        )
      })}
      <DailyCutileiServicesModal
        visible={showDetails}
        schedules={selectedSchedules}
        onClose={() => setShowDetails (false)}
      />
    </Container>
  )
}
